import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'

function ErrorFallback({ error }: { error: Error }) {
  return (
    <div role="alert">
      There was an error:{' '}
      <pre style={{ whiteSpace: 'normal' }}>{error.message}</pre>
    </div>
  )
}

export function SurveyErrorBoundary(props: React.PropsWithChildren<unknown>) {
  return <ErrorBoundary FallbackComponent={ErrorFallback} {...props} />
}
